import { render, staticRenderFns } from "./figment-research.vue?vue&type=template&id=2b7059c2&"
import script from "./figment-research.vue?vue&type=script&lang=js&"
export * from "./figment-research.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports